export const REGISTRATION_CODE_WINDOW_MINUTES = 15;
export const REGISTRATION_CODE_WINDOW_SECONDS =
  REGISTRATION_CODE_WINDOW_MINUTES * 60;
export const REGISTRATION_CODE_WINDOW_MS =
  REGISTRATION_CODE_WINDOW_SECONDS * 1_000;

export function registrationCodeDeadlineMs(nowMs = Date.now()): number {
  return nowMs + REGISTRATION_CODE_WINDOW_MS;
}

export function registrationCodeSecondsRemaining(
  deadlineMs: number,
  nowMs = Date.now(),
): number {
  return Math.max(0, Math.ceil((deadlineMs - nowMs) / 1_000));
}

export function formatRegistrationCodeTime(seconds: number): string {
  const safeSeconds = Math.max(0, Math.floor(seconds));
  const minutes = Math.floor(safeSeconds / 60);
  const remainder = safeSeconds % 60;
  return `${minutes}:${String(remainder).padStart(2, "0")}`;
}
